// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2p7Cl","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1EdGq","obliqueLine":"membershipbadge_obliqueLine__1IUdw"};